import { useMemo } from "react";
import { useAppSelector } from "../../../app/hooks";
import { selectMembers } from "../members-slice";
import { useEnsureDirectoryLoaded } from "./useEnsureDirectoryLoaded";

/**
 * Loads the member directory (once) and returns a resolver from member id to
 * display name. Members not (yet) in the directory render as "Unknown member"
 * rather than leaking a guid fragment into the UI.
 */
export function useMemberNameLookup(): (memberId: string) => string {
  useEnsureDirectoryLoaded();
  const members = useAppSelector(selectMembers);

  return useMemo(() => {
    const byId = new Map(members.map((m) => [m.id, `${m.firstName} ${m.lastName}`]));
    return (memberId: string) => byId.get(memberId) ?? "Unknown member";
  }, [members]);
}
